// import { DatePipe } from "@angular/common";

// export class Formatteddate {

//     constructor(public datePipe: DatePipe,){

//     }

//     getMMDDYYYY(date) {
//         var today = new Date(date);
//         console.log(date);

//         var dd = today.getDate();
//         var mm = today.getMonth() + 1;
//         var yyyy = today.getFullYear();

//         // if (dd < 10)
//         //     dd = 0 + dd
//         // if (mm < 10)
//         //     mm = 0 + mm
//         // return mm + '/' + dd + '/' + yyyy;

//           const formattedDate =  (mm <10 ? '0' + mm : mm) + '/' + (dd <10 ? '0'+ dd : dd) + '/' + yyyy;
//           return this.datePipe.transform(formattedDate, 'yyyy-MM-dd'); 
//       }
// }

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormatPipe',
})

export class dateFormatPipe implements PipeTransform {

    transform(value: string) {  // not using
        const datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, 'yyyy-MM-dd');
        return value;
    }

    getMMDDYYYY(date) {
        var today = new Date(date);
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        const datePipe = new DatePipe("en-US");
        const formattedDate = (mm < 10 ? '0' + mm : mm) + '/' + (dd < 10 ? '0' + dd : dd) + '/' + yyyy;
        return datePipe.transform(formattedDate, 'yyyy-MM-dd');
    }
}
